import * as React from 'react';
import { IPolicyHandler } from '../policy/IPolicyHandler';
import { IEventHandler, Policy } from './IEventHandler';

export interface BeforeSubmitPracticeTestData {
  remainTimeInSeconds: number;
  remainQuestion: number;
  completeTimeInMinutes: number;
  onSubmit: (userExperienceData) => void;
  routeTo?: () => void;
}

export interface BeforeSubmitPracticeTestEvent {
  beforeSubmitPracticeTest: Policy[];
}

export const useBeforeSubmitPracticeTestEvent = (policyHandler: IPolicyHandler) => {
  return React.useMemo(() => new BeforeSubmitPracticeTestEventHandler(policyHandler), [
    policyHandler,
  ]);
};

export class BeforeSubmitPracticeTestEventHandler
  implements IEventHandler<BeforeSubmitPracticeTestEvent, BeforeSubmitPracticeTestData> {
  policyHandler: IPolicyHandler;

  constructor(policyHandler: IPolicyHandler) {
    this.policyHandler = policyHandler;
  }

  async handle(
    event: BeforeSubmitPracticeTestEvent,
    data: BeforeSubmitPracticeTestData
  ): Promise<void> {
    const policies = event.beforeSubmitPracticeTest;
    for (const policy of policies) {
      if (this.policyHandler.canHandlePolicy(policy, data)) {
        return this.policyHandler.handlePolicy(policy, data).then(() => {});
      }
    }
    return Promise.resolve();
  }
}
